module.exports = __webpack_public_path__ + "img/hotel-occidental-lisboa.df7ca127.jpg";